/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Settings_Groups_Plausible_DescriptionInputs */

const en_admin_settings_groups_plausible_description = /** @type {(inputs: Admin_Settings_Groups_Plausible_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Supports both site-specific and legacy scripts for self-hosted or cloud Plausible`)
};

const zh_admin_settings_groups_plausible_description = /** @type {(inputs: Admin_Settings_Groups_Plausible_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`支持云版或自托管 Plausible 的新版站点专属脚本及旧版脚本`)
};

/**
* | output |
* | --- |
* | "Supports both site-specific and legacy scripts for self-hosted or cloud Plausible" |
*
* @param {Admin_Settings_Groups_Plausible_DescriptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_settings_groups_plausible_description = /** @type {((inputs?: Admin_Settings_Groups_Plausible_DescriptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Settings_Groups_Plausible_DescriptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_settings_groups_plausible_description(inputs)
	return zh_admin_settings_groups_plausible_description(inputs)
});
export { admin_settings_groups_plausible_description as "admin.settings.groups.plausible.description" }